import {
  Form,
  Input,
  Button,
  Row,
  message,
} from "antd";
import "moment/locale/pt-br";
import { useNavigate } from "react-router-dom";

import {
  Container,
} from "./styles";

import { useTemplateCivilTypes } from "../../hooks/useTemplateCivilTypes";

export function NewTemplateCivilType() {
  const navigate = useNavigate();

  const {
    createTemplateType,
    fetchTemplateType,
    handleModalVisible,
  } = useTemplateCivilTypes();

  return (
    <Container>
        <Form
            onFinish={async (form) => {
                const status = await createTemplateType(form);

                if (status) message.success("Aprovado");
                else message.warning("Falha");

                handleModalVisible(false);
                fetchTemplateType(1, 'asc', 'title');
                navigate('/template-civil-types/1');
            }}
        >
          <Form.Item
              name="title"
              label="Nome"
              style={{
                  marginBottom: "25px",
              }}
              rules={[
                  {
                      required: true,
                      message: "Este campo é obrigatório!",
                  },
              ]}
          >
              <Input maxLength={50} placeholder="Nome" />
          </Form.Item>

          <Form.Item
              name="description"
              label="Descrição"
              style={{
                  marginBottom: "25px",
              }}
              rules={[]}
          >
              <Input maxLength={100} placeholder="Descrição" />
          </Form.Item>

          <Row justify="end">
            <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    marginRight: "10px",
                  }}
                >
                  Salvar
                </Button>

                <Button
                  onClick={() => handleModalVisible(false)}
                >
                  Cancelar
                </Button>
            </Form.Item>
          </Row>
      </Form>
    </Container>
  );
}
